import React, { Component } from "react";

import { Row } from "react-bootstrap";

import moment from "moment/moment";

import Popup from "react-popup";

import Booking from "./Booking";
import Bookings from "./Bookings";
import CenterList from "./CenterList";
import SportSolutionApiWrapper from "../utils/SportSolutionApiWrapper";

import "./App.css";

class App extends Component {
  constructor() {
    super();
    moment.locale(document.querySelector("html").attributes.lang.value);
    this.setUser = this.setUser.bind(this);
    this.logout = this.logout.bind(this);
    this.setCenter = this.setCenter.bind(this);
    this.setCenters = this.setCenters.bind(this);
    this.fetchEvents = this.fetchEvents.bind(this);
    this.getBookings = this.getBookings.bind(this);
    this.getCenterNameById = this.getCenterNameById.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.popup = this.popup.bind(this);
    this.setSelectedDate = this.setSelectedDate.bind(this);

    this.state = {
      user: null,
      events: [],
      centers: [],
      selectedCenterId: null,
      bookings: {},
      selectedDate: null,
      dateOffset: 0,
      i18nKeeper: document.querySelector("#i18n").dataset,
    };
  }

  componentWillMount() {
    this.setState({ dateOffset: parseInt(this.props.dateOffset) });
    this.setUser();
  }

  componentWillUpdate(_nextProps, nextState) {
    if (nextState.user && nextState.user != this.state.user) {
      this.getBookings();
    }
  }

  getCenterNameById(centerId) {
    const centers = this.state.centers.filter(x => x.id == centerId);
    if (centers.length) {
      return centers[0].name;
    }
    return "none";
  }

  getBookings(_user = null) {
    const ssaw = new SportSolutionApiWrapper();
    ssaw.bookings(resp => {
      let bookings = {};
      if (resp.ss_participations) {
        for (let booking of resp.ss_participations) {
          booking.start = this.fixDate(booking.start_date_time);
          booking.start_hour = moment(booking.start).format("HH");
          bookings[booking.ss_event.id] = booking;
        }
      }
      this.setState({ bookings: bookings });
    });
  }

  setUser() {
    const ssaw = new SportSolutionApiWrapper();
    const that = this;
    ssaw.login(function(resp) {
      that.setState({
        user: { username: resp.username, info: resp.user_info },
      });
      if (resp.user_info.password_update_required) {
        document.location = "/password/edit?change_password=1";
      }
    });
  }

  popup(text) {
    Popup.alert(text);
  }

  fixDate(date_from_json) {
    let d = moment.utc(date_from_json).local();
    if (d.format("Z") == "+00:00") {
      d.set("hour", d.get("hour") + this.state.dateOffset);
    }
    return d;
  }
  fetchEvents(center_id, date) {
    this.setState({ events: [] });
    let ssaw = new SportSolutionApiWrapper();
    let that = this;

    ssaw.events(center_id, date, function(resp) {
      let events = new Array();

      for (let event of resp.ss_events) {
        event.start = that.fixDate(event.start_date_time);

        event.end = that.fixDate(event.end_date_time);
        // event.end = event.end.setMinutes(event.end.getMinutes() + event.duration / 60);
        event.start_hour = event.start.format("HH");
        event.start_minute = event.start.format("mm");
        event.end_hour = event.end.format("HH");
        event.end_minute = event.end.format("mm");
        events.push(event);
      }
      that.setState({ events: events });
    });
  }

  setCenter(center_id) {
    this.setState({
      selectedCenterId: center_id,
    });
    if (this.state.selectedDate && center_id) {
      this.fetchEvents(center_id, this.state.selectedDate);
    }
  }

  setCenters(centers) {
    this.setState({ centers: centers });
  }

  setSelectedDate(date) {
    this.setState({ selectedDate: date });
    if (date && this.state.selectedCenterId) this.fetchEvents(this.state.selectedCenterId, date);
  }

  logout(event) {
    event.preventDefault();
    this.setState({ user: null });
  }

  hideModal(event) {
    this.setState({ showModal: false });
  }

  bookedClassesLabel() {
    if (!this.state.user) return "";

    return render(<h2>{this.state.i18nKeeper.bookedClasses}</h2>);
  }

  render() {
    if (!this.state.user) {
      return <div>Not signed in...</div>;
    }
    let ssaw = new SportSolutionApiWrapper();
    let gymName = this.getCenterNameById(this.state.selectedCenterId);

    return (
      <Row className="App">
        <div className="booked">
          {this.bookedClassesLabel}
          <Bookings
            bookings={this.state.bookings}
            getBookings={this.getBookings}
            user={this.state.user}
            popup={this.popup}
            getCenterNameById={this.getCenterNameById}
          />
        </div>
        <div className="booking">
          <h3>
            {gymName} <i className="fa fa-angle-down" aria-hidden="true" />
          </h3>
          <CenterList
            centers={this.state.centers}
            user={this.state.user}
            setCenter={this.setCenter}
            setCenters={this.setCenters}
          />
          <Booking
            events={this.state.events}
            fetchEvents={this.fetchEvents}
            user={this.state.user}
            selectedCenterId={this.state.selectedCenterId}
            setSelectedDate={this.setSelectedDate}
            bookings={this.state.bookings}
            getBookings={this.getBookings}
            popup={this.popup}
          />
        </div>
        <Popup />
      </Row>
    );
  }
}

export default App;
